import styled from 'react-emotion';
import { getRgbaColor } from '../../utils/color';

export const ZoomWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  user-select: none;
`;

export const ZoomTriggerWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  user-select: none;
  cursor: ${props => (props.zoomed ? 'zoom-out' : 'zoom-in')};
`;

export const ZoomFlyoutWrapper = styled('div')`
  position: absolute;
  background-color: ${props => props.bgColor};
  width: ${props => Number(props.width)}px;
  height: ${props => Number(props.height)}px;
  border-radius: ${props => props.radius}px;
  left: ${props => props.coords.x}px;
  top: ${props => props.coords.y}px;
  ${props => (props.zIndex ? `z-index:${props.zIndex}` : '')};
  ${props => (props.renderToContainer ? '' : 'overflow: hidden;')};
  ${props => (props.useOpacity ? (props.zoomed ? 'opacity: 1;' : 'opacity: 0;') : '')};
  ${props => (props.useOpacity ? 'transition: opacity 450ms;' : '')};
`;

export const ZoomImage = styled('img')`
  position: absolute;
  width: ${props => (props.zoomed ? props.level * props.width : props.width)}px;
  height: ${props => (props.zoomed ? props.level * props.height : props.height)}px;
  max-width: none !important;
  max-height: none !important;
  opacity: ${props => (props.zoomed ? 1 : 0)};
`;

export const ZoomLens = styled('div')`
  width: ${props => Number(props.width)}px;
  height: ${props => Number(props.height)}px;
  border-radius: ${props => props.radius}px;
  ${props => (Number(props.top) ? `top:${Number(props.top)}px` : '')};
  ${props => (Number(props.left) ? `left:${Number(props.left)}px` : '')};
  position: absolute;
  opacity: ${props => (props.show ? 1 : 0)};
  background-color: ${props => getRgbaColor(props.color, props.opacity)};
  ${props =>
    props.shadow
      ? 'box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px 0 rgba(0, 0, 0, 0.2);'
      : ''};
  ${props =>
    props.borderWidth > 0 ? `border: ${props.borderWidth}px solid ${props.borderColor};` : ''};
`;
